import { useContext, useMemo } from 'react';
import { AuthUserContext } from '../../../components/Session';

const useFranchiseeWorkspace = () => {
  const authUser = useContext(AuthUserContext);
  const uid = authUser?.uid || null;

  return useMemo(() => {
    if (!uid) {
      return {
        franchiseeId: null,
        uid: null,
        loading: false,
        error: 'AUTH_REQUIRED',
      };
    }

    return {
      franchiseeId: uid,
      uid,
      loading: false,
      error: null,
    };
  }, [uid]);
};

export default useFranchiseeWorkspace;
